import { Link } from 'react-router-dom';

const footerLinks = {
  游戏分类: [
    { label: '角色扮演', to: '/category/role-playing' },
    { label: '策略塔防', to: '/category/strategy' },
    { label: '射击竞技', to: '/category/shooting' },
    { label: '休闲益智', to: '/category/casual' },
  ],
  热门推荐: [
    { label: '热血江湖传', to: '/article/rexue-jianghu-review' },
    { label: '开心消消乐园', to: '/category/casual' },
    { label: '三国群英战', to: '/category/strategy' },
    { label: '跑跑卡丁车OL', to: '/category/casual' },
  ],
  关于我们: [
    { label: '品牌介绍', to: '/about' },
    { label: '联系方式', to: '/about' },
    { label: '游戏资讯', to: '/article' },
    { label: '新手攻略', to: '/article/web-game-beginner-guide' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-flex items-center gap-2 mb-4">
              <span className="text-2xl font-heading text-primary-400">18</span>
              <span className="text-base font-semibold text-background-50 whitespace-nowrap">网页游戏</span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              精选热门网页游戏大全，无需下载即点即玩。覆盖角色扮演、策略、射击、休闲等多种类型，随时随地开启游戏乐趣。
            </p>
          </div>
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href={`#footer-${title}`} className="hover:text-primary-400 transition-colors duration-200">{title}</a>
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-10 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 18网页游戏 - 精选热门网页游戏大全. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-400 hover:text-primary-400 transition-colors duration-200 w-9 h-9 flex items-center justify-center" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-background-400 hover:text-primary-400 transition-colors duration-200 w-9 h-9 flex items-center justify-center" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-400 hover:text-primary-400 transition-colors duration-200 w-9 h-9 flex items-center justify-center" aria-label="QQ">
              <i className="ri-qq-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}